import ActionTypes from '../constants/ActionTypes';

/* Actions */

export const createFactory = (data) => ({
  type: ActionTypes.FACTORY_CREATE,
  payload: {
    data,
  },
});

export const updateFactory = (id, data) => ({
  type: ActionTypes.FACTORY_UPDATE,
  payload: {
    id,
    data,
  },
});

export const deleteFactory = (id) => ({
  type: ActionTypes.FACTORY_DELETE,
  payload: {
    id,
  },
});

/* Events */

export const createFactoryRequested = (data) => ({
  type: ActionTypes.FACTORY_CREATE_REQUESTED,
  payload: {
    data,
  },
});

export const createFactorySucceeded = (factory, users, factoryMemberships, sites) => ({
  type: ActionTypes.FACTORY_CREATE_SUCCEEDED,
  payload: {
    factory,
    users,
    factoryMemberships,
    sites,
  },
});

export const createFactoryFailed = (error) => ({
  type: ActionTypes.FACTORY_CREATE_FAILED,
  payload: {
    error,
  },
});

export const createFactoryReceived = (factory, factoryMembership) => ({
  type: ActionTypes.FACTORY_CREATE_RECEIVED,
  payload: {
    factory,
    factoryMembership,
  },
});

export const updateFactoryRequested = (id, data) => ({
  type: ActionTypes.FACTORY_UPDATE_REQUESTED,
  payload: {
    id,
    data,
  },
});

export const updateFactorySucceeded = (factory) => ({
  type: ActionTypes.FACTORY_UPDATE_SUCCEEDED,
  payload: {
    factory,
  },
});

export const updateFactoryFailed = (id, error) => ({
  type: ActionTypes.FACTORY_UPDATE_FAILED,
  payload: {
    id,
    error,
  },
});

export const updateFactoryReceived = (factory) => ({
  type: ActionTypes.FACTORY_UPDATE_RECEIVED,
  payload: {
    factory,
  },
});

export const updateFactoryBackgroundImageRequested = (id) => ({
  type: ActionTypes.FACTORY_BACKGROUND_IMAGE_UPDATE_REQUESTED,
  payload: {
    id,
  },
});

export const updateFactoryBackgroundImageSucceeded = (factory) => ({
  type: ActionTypes.FACTORY_BACKGROUND_IMAGE_UPDATE_SUCCEEDED,
  payload: {
    factory,
  },
});

export const updateFactoryBackgroundImageFailed = (id, error) => ({
  type: ActionTypes.FACTORY_BACKGROUND_IMAGE_UPDATE_FAILED,
  payload: {
    id,
    error,
  },
});

export const deleteFactoryRequested = (id) => ({
  type: ActionTypes.FACTORY_DELETE_REQUESTED,
  payload: {
    id,
  },
});

export const deleteFactorySucceeded = (factory) => ({
  type: ActionTypes.FACTORY_DELETE_SUCCEEDED,
  payload: {
    factory,
  },
});

export const deleteFactoryFailed = (id, error) => ({
  type: ActionTypes.FACTORY_DELETE_FAILED,
  payload: {
    id,
    error,
  },
});

export const deleteFactoryReceived = (factory) => ({
  type: ActionTypes.FACTORY_DELETE_RECEIVED,
  payload: {
    factory,
  },
});
